import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  addUserCard,
  getUserDetails,
  removeUserCard,
  selectAddress,
  selectCard,
  topUpWallet,
} from "../../actions";
import CardListItem from "./CardListItem";
import { BILLING, CARD_LIST, MPESA } from "../../../constants/types";
import CardForm from "./CardForm";
import { ReactComponent as RemoveIcon } from "../../../assets/remove-card-icon.svg";
import MessageBlock from "../common/MessageBlock";
import PAYSTACK_COUNTRIES from "../../../assets/paystackCountries.json";

const CardList = (props) => {
  const [showCardForm, toggleCardForm] = useState(false);
  const [showConfirmation, toggleConfirmation] = useState(false);

  useEffect(() => {
    props.getUserDetails();
    toggleConfirmation(false);
    props.selectAddress(props.defaultAddress, BILLING);
  }, []);

  const deleteCard = (card) => {
    props.removeUserCard(card.id, () => {
      toggleConfirmation(false);
      props.selectCard(null, CARD_LIST, () => {
        return;
      });
    });
  };

  const renderList = (cards) => {
    return cards.map((item, id) => {
      return (
        <CardListItem
          card={item}
          key={id}
          type={CARD_LIST}
          showOverlay={() => toggleConfirmation(true)}
        />
      );
    });
  };
  const paystackCountry = PAYSTACK_COUNTRIES.find(
    (country) => props.billingAddress?.country === country.country,
  );
  const amount = parseFloat(paystackCountry?.minAmount || 1);
  const currency = paystackCountry?.currency || "KES";

  const renderCardForm = () => {
    return (
      showCardForm && (
        <div className="modal d-flex justify-content-center justify-content-lg-start aligin-items-center">
          <div onClick={() => toggleCardForm()} className="backdrop"></div>
          <div className="modal-content settings-card create-card d-flex col-11 col-lg-6 col-xl-4 m-auto ">
            <div className="card-section head d-flex flex-row justify-content-between">
              <h5>Save Payment Method</h5>
              <a className="d-flex " onClick={() => toggleCardForm()}>
                Close
              </a>
            </div>
            <CardForm
              onFinish={() => toggleCardForm(!showCardForm)}
              paystackCharge={{
                amount,
                currency,
                onSuccess: (transaction) => {
                  props.topUpWallet(null, amount, currency, transaction, () => {
                    toggleCardForm(!showCardForm);
                    props.getUserDetails();
                    if (props.defaultAddress?.id)
                      props.selectAddress(props.defaultAddress, BILLING);
                  });
                },
                loading: props.loading || props.loadingTopUp,
              }}
            />
          </div>
        </div>
      )
    );
  };

  const renderConfirmation = () => {
    if (showConfirmation) {
      return (
        <div className="modal">
          <div
            className="backdrop"
            onClick={() => toggleConfirmation(false)}
          ></div>
          <div className="modal-content confirmation">
            <RemoveIcon />
            <div>
              <p>
                You are about to delete payment method{" "}
                <b>
                  {props.selected?.payment_method_type === MPESA
                    ? props.selected?.details?.mobile_money_phone_number
                    : `**** ${props.selected?.details?.last4}`}
                </b>
              </p>
              <p>Are you sure?</p>
            </div>
            <div className="col-12 p-0 d-flex flex-column flex-lg-row justify-content-between">
              <button onClick={() => toggleConfirmation(!showConfirmation)}>
                Cancel
              </button>
              <button
                onClick={() => deleteCard(props.selected)}
                className="delete-button"
              >
                {props.loading ? (
                  <div className="spinner-border m-auto" role="status"></div>
                ) : (
                  "Delete Payment Method"
                )}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="settings-card cards-content col-12">
      {!!props.errors ||
        (props.topUpError && (
          <MessageBlock
            type={"error"}
            message={props.errors || props.topUpError}
          />
        ))}
      <div className="card-section head col-12 d-flex flex-row justify-content-between align-items-center flex-wrap">
        <div className="d-flex flex-row align-items-center">
          <h3>Payment Methods</h3>
          <p
            onClick={() => props.getUserDetails()}
            className="refresh-btn mb-0 mx-3"
          >
            Refresh
          </p>
        </div>
        <a
          onClick={() => toggleCardForm(true)}
          className="action d-flex flex-row align-items-center"
        >
          Add New Payment
        </a>
      </div>
      <div>
        <div className="cards-list list-group">
          {props.loading ? (
            <div className={"card-section last card-list-item"}>
              <div className="spinner-border text-dark m-auto" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {props.cards?.length > 0 ? (
                renderList(props.cards)
              ) : (
                <div className={`card-list-item card-section last`}>
                  No Payment Methods saved
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {renderCardForm()}
      {renderConfirmation()}
    </div>
  );
};

const mapStateToProps = ({ userDetails, wallets, billingAddress }) => ({
  cards: userDetails.cards,
  loading: userDetails.loading,
  errors: userDetails.errors,
  selected: userDetails.selectedCard,
  defaultAddress: userDetails.info?.default_address,
  loadingTopUp: wallets.loadingTopUp,
  topUpError: wallets.topUpError,
  billingAddress,
});

export default connect(mapStateToProps, {
  getUserDetails,
  removeUserCard,
  selectCard,
  selectAddress,
  addUserCard,
  topUpWallet,
})(CardList);
